import type { ReactNode } from "react";
import classNames from "classnames/dedupe";
import type { DOMProps } from "../../types/dom";

export interface SegmentProps extends DOMProps {
  className?: string;
  heading?: string;
  /** Background colour for Segment */
  colour?: "subtle" | "primary" | "secondary";
  /** When inverted, text is white.  Use on darker backgrounds. */
  inverted?: boolean;
  children?: ReactNode;
}

const Segment = (props: SegmentProps) => {
  const { heading, children, colour, inverted, className, ...rest } = props;

  const classes = classNames(
    "mobius",
    "mobius-segment",
    colour,
    { inverted },
    className,
  );

  return (
    <div className={classes} {...rest}>
      {heading && <div className="mobius-segment__heading">{heading}</div>}
      {children}
    </div>
  );
};

Segment.displayName = "Segment";
export { Segment };
